export interface FormField {
  readonly name: string
  readonly type: string
  readonly placeholder: string
  readonly icon?: string
  readonly iconClass?: string
  readonly required?: boolean
}

export interface ContactFormFields {
  readonly personal: readonly FormField[]
  readonly child: readonly FormField[]
}

export const contactFormFields: ContactFormFields = {
  personal: [
    { name: 'firstName', type: 'text', placeholder: 'Your First Name', required: true },
    { name: 'surname', type: 'text', placeholder: 'Your Surname', required: true },
    { name: 'email', type: 'email', placeholder: 'Your Email Address', required: true },
    { name: 'mobile', type: 'text', placeholder: 'Your Mobile', required: true },
    { name: 'postcode', type: 'text', placeholder: 'Your Postcode', required: true },
  ] as const,
  child: [
    { name: 'daysRequired', type: 'text', placeholder: 'Number of Days Required' },
    { name: 'startDate', type: 'text', placeholder: 'Start Date Required dd/mm/yyyy' },
    { name: 'ageGroup', type: 'text', placeholder: 'Age Group' },
    { name: 'childDOB', type: 'text', placeholder: "Child's DOB dd/mm/yyyy" },
    { name: 'message', type: 'textarea', placeholder: 'Please include any additional comments' },
  ] as const,
} as const
